import * as React from 'react'
import { History } from 'history'
import { IMap, IIntegration, IProviderProductObject, IAddOn } from '../../../../../../types/index'
import EditBottom from '../EditBottom'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import { Select } from '@mobiscroll/react-latest'
import { withNotification } from 'src/components/ui/notification-provider'
import history from 'src/history'

interface IIntegrationFormProps {
  selectedIntegration: { value: string; label: string } | null
  integrations: IMap<IIntegration>
  product: IProviderProductObject
  saveProduct: (product: IProviderProductObject) => Promise<any>
  history?: History
  notification?: any
}

interface IIntegrationFormState {
  isSaved: boolean
  isSaving: boolean
  integration: { value: string; label: string } | null
}

class IntegrationForm extends React.Component<IIntegrationFormProps, IIntegrationFormState> {
  constructor(props: IIntegrationFormProps) {
    super(props)
    this.state = {
      isSaved: false,
      isSaving: false,
      integration: props.selectedIntegration
    }
  }

  public render() {
    const { integration, isSaved, isSaving } = this.state
    const { product, history } = this.props

    return (
      <div>
        <FloatingForm fullHeight={true}>
          <div className='form-modal-section full-section'>
            <section className='p2'>
              <div className='font-grey2 bold h5 mb1'>External API Integration</div>
              <div className='mt1 border-top pt2'>
                <div className='w50p'>
                  <Select
                    placeholder='Select Integration'
                    value={integration}
                    data={this.renderIntegrationOptions()}
                    onChange={this.selectIntegration}
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`External API`}
                    labelStyle='floating'
                  />
                </div>
              </div>
            </section>
          </div>
        </FloatingForm>
        <EditBottom
          isSaving={isSaving}
          cancelPath={`/products/${product.id}/integration`}
          onSave={this.onSave}
          history={history}
        />
      </div>
    )
  }

  private selectIntegration = (option: any) => {
    this.setState({
      integration: option
    })
  }

  private onSave = () => {
    const { integration } = this.state
    const { product, saveProduct, notification } = this.props
    let { serviceLevelId } = product
    if (!serviceLevelId && product.providerServiceLevel) {
      serviceLevelId = product.providerServiceLevel.id
    }
    if (!integration || !integration.value) {
      return
    }
    const updatedProduct: any = Object.assign({}, product, {
      integrationId: integration.value,
      serviceLevelId
    })

    const fixedValues = {
      ...updatedProduct,
      pricing: {
        ...updatedProduct.pricing,
        addOn: updatedProduct.pricing.addOn.reduce((acc: Record<string, number>, item: IAddOn) => {
          acc[item.label] = item.price
          return acc
        }, {})
      }
    }
    saveProduct(fixedValues).then(response => {
      notification.addNotification({
        title: 'Success',
        message: 'Product Integration Saved Successfully',
        level: 'success'
      })
    })
    history.push(`/products/${product.id}/integration`)
  }

  private renderIntegrationOptions = () => {
    console.log(this.props.integrations)
    if (JSON.stringify(this.props.integrations) === '{}') {
      return [
        {
          value: '',
          text: 'No integrations available',
          disabled: true
        }
      ]
    }
    const results = Object.values(this.props.integrations).map(integration => {
      return {
        value: integration.uuid,
        text: integration.name
      }
    })

    console.log('results: ', results)
    return results
  }
}

export default withNotification(IntegrationForm)



// WEBPACK FOOTER //
// ./src/components/products/details/product/edit/pane/ProductIntegration.tsx